import { Message } from "./message";
import { v4 as uuidv4 } from "uuid";

export class Producer {
    uid: string;
    recentMessage?: Message;
    interval: number = 1;
    counter: number = 0;

    constructor() {
        this.uid = uuidv4();
    }
}
